resourcePaths = '{"rootPath":"/member","assetsPath":"/member/assets"}';/*
    APIModel

    APIModel description.

    Parameters:
        name
        uri
        callbackOrPromise
        setInitialized

    Methods (see methods for additional usage):

        updateModel(data, callbackOrPromise)

        resetModel()

        performAction(action, callbackOrPromise)

        hasAction(action)

        isInitialized()

        isPersistent()

        getSchema(action, callbackOrPromise, localStoreBool)

        setModelProperty(property, value)

        removeModelProperty(property)

        getModelProperty(value)

        getActionUri(action)
*/

function APIModel (name, uri, callbackOrPromise, setInitialized) {
  this._name = name;

  this._uri = null;
  this._schemas = {};
  this._memory = {};
  this._links = {};
  this._persistent = true;
  this._initialized = false || setInitialized;
  this._initializedPromise = $.Deferred();
  this._pendingCallbacks = [];
  this._lock = false;
  this._maxDepthError = false;

  this._MAX_DEPTH = 10;

  if (typeof uri === 'string') {
    this._uri = uri;
    this._getModelWithURI(callbackOrPromise);
  }
}

/*
    Updates the model. If data is provided, it updates with the data.
    Otherwise, it updates by making a call to the backend API.

    Arguments:
        data [object]:
            adds properties inside data object to the model.
        callbackOrPromise [function or Promise / Deferred] (optional):
            if a function, it is called after the model is updated
            if a Promise or Deferred obj, it is resolved after the model is updated
        nestedModel [string] (optional):
            The path to the nested model.
*/
APIModel.prototype.updateModel = function (data, callbackOrPromise, nestedModel) {
  //if (!mogo.registry.timing) mogo.registry.timing = [];
  //var start = performance.now();

  if (nestedModel) {
    var model = this._getObjectProperty(this, nestedModel);
    model.updateModel(data, callbackOrPromise);
    return;
  }

  if (data != null) {
    try {
      this._obtainLock();
    } catch (e) {
      this._addCallbackToPending(callbackOrPromise);
      throw e;
    }

    // Construct memory to track dirty
    this._memory = data;

    // Process data
    data = this._processData(data);
    for (var prop in data) {
      // Apply properties to this model
      if (prop.indexOf('_') !== 0 && this[prop] !== data[prop]) {
        this[prop] = data[prop];
      }
    }

    // Process Links
    this._links = {};
    var actions = this._processLinks(data);
    if (actions) {
      this._links = actions;
    }

    // Cleanup undefined properties
    for (var prop in this) {
      if (
        typeof this[prop] !== 'function' &&
        !(this[prop] instanceof APIModel) &&
        prop.indexOf('_') != 0 &&
        typeof data[prop] === 'undefined'
      ) {
        delete this[prop];
      }
    }

    //var end = performance.now();
    //mogo.registry.timing.push(end - start);

    this._initialized = true;
    this._persistent = true;
    this._releaseLock();
    this._callPendingCallbacks();
    this._doMethodCompletion(true, callbackOrPromise, data);
    this._initializedPromise.resolve(data);
  } else {
    this._getModel(callbackOrPromise);
  }
};

/*
    Resets model to its original state, which is the state when fetched from API.

    Arguments:
        nestedModel [string] (optional):
            The path to the nested model.

    Returns:
        [boolean]
            true on complete
*/
APIModel.prototype.resetModel = function (nestedModel) {
  if (nestedModel) {
    var model = this._getObjectProperty(this, nestedModel);
    return model.resetModel();
  }

  this.updateModel(this._memory);
  this._persistent = true;
  return true;
};

/*
    Checks whether an action in the model exists and performs the action.

    Arguments:
        action [string] (required):
            The name of the action.
        data [object] (optional):
            The data to be included in the execution of the action.
        callbackOrPromise [function or Promise / Deferred] (optional):
            if a function, it is called after the action is performed
            if a Promise or Deferred obj, it is resolved after the action is performed
        requestOptions [object]/[Integer] (optional):
            APIRequest options e.g. {polling_interval: 1, polling_timeout: 30} in seconds.
            APIRequest polling interval in milliseconds. Defaults to APIRequest default (1000).
            link.options from BE will override FE provided requestOptions params

    Returns:
        [boolean]
            false if action does not exist.
*/
APIModel.prototype.performAction = function (action, data, callbackOrPromise, requestOptions) {
  if (this.hasAction(action)) {
    var index = action.lastIndexOf('.');
    if (index === -1) {
      var link = this._links[action];
      if (link) {
        var request = new APIRequest(
            link.uri,
            link.method,
            data,
            this._onAction.bind(this, callbackOrPromise),
            link.options || requestOptions
        );
        request.send();
        return request;
      }
    } else {
      var actionPath = action.substring(0, index);
      action = action.substring(index + 1);
      var model = this._getObjectProperty(this, actionPath);
      if (model instanceof APIModel) {
        if (model.hasAction(action)) {
          var request = model.performAction(action, data, callbackOrPromise, requestOptions);
          return request;
        }
      }
    }
  }

  // Link does not exist
  this._doMethodCompletion(true, callbackOrPromise, data);
  this._releaseLock();
  return false;
};

/*
    Checks whether an action in the model exists.

    Arguments:
        action [string] (required):
            The name of the action.

    Returns:
        [boolean]
            true if action exists, false otherwise.
*/
APIModel.prototype.hasAction = function (action) {
  var index = action.lastIndexOf('.');
  if (index === -1) {
    if (typeof this._links[action] !== 'undefined') return true;
    return false;
  } else {
    var actionPath = action.substring(0, index);
    action = action.substring(index + 1);
    var model = this._getObjectProperty(this, actionPath);
    if (model instanceof APIModel) {
      if (model.hasAction(action)) {
        return true;
      }
    }
  }

  return false;
};

/*
    Checks if the model has been initialized and can be used as a data source.

    Arguments:
        none

    Returns:
        [boolean]
            true if model is initialized, false otherwise.
*/
APIModel.prototype.isInitialized = function () {
  return this._initialized;
};

/*
    Checks if the state of the model reflects what is in the database.
    If model has been modified but not yet saved to database, it's state is not persistent.

    Arguments:
        none

    Returns:
        [boolean]
            true if model is persistent, false otherwise.
*/
APIModel.prototype.isPersistent = function () {
  return this._persistent;
};

/*
    Get the schema for a specific action.

    Arguments:
        action [string] (required):
            The name of the action.
        callbackOrPromise [function or Promise / Deferred]:
            if a function, it is called after the schema has been retrieved
            if a Promise or Deferred obj, it is resolved after the schema has been retrieved
*/
APIModel.prototype.getSchema = function (action, callbackOrPromise, localStoreBool) {
  if (!this.hasAction(action)) {
    this._doMethodCompletion(false, callbackOrPromise, null);
  }

  var index = action.lastIndexOf('.');
  if (index === -1) {
    if (this._schemas[action] != null) {
      this._doMethodCompletion(true, callbackOrPromise, this._schemas[action]);
    } else {
      this._loadSchema(action, callbackOrPromise, localStoreBool);
    }
  } else {
    var actionPath = action.substring(0, index);
    action = action.substring(index + 1);
    var model = this._getObjectProperty(this, actionPath);
    if (model instanceof APIModel) {
      model.getSchema(action, callbackOrPromise, localStoreBool);
    }
  }
};

/*
    Adds a new property to model with the value specified.

    Arguments
        modelProperty [string]
            property name
        value
            can be of any type
*/
APIModel.prototype.setModelProperty = function (modelProperty, value) {
  try {
    this._obtainLock();
  } catch (e) {
    throw e;
  }

  if (this.getModelProperty(modelProperty) != value) {
    this._setObjectProperty(this, modelProperty, value);
  }
  this._releaseLock();
  this._callPendingCallbacks();
  this._initialized = true;
  this._initializedPromise.resolve();
};

/*
    Removes a property from model.

    Arguments
        modelProperty [string]
            property name
*/
APIModel.prototype.removeModelProperty = function (modelProperty) {
  try {
    this._obtainLock();
  } catch (e) {
    throw e;
  }

  if (this.getModelProperty(modelProperty) !== undefined) {
    this._removeObjectProperty(this, modelProperty);
    this._persistent = false;
  }
  this._releaseLock();
  this._callPendingCallbacks();
  this._initialized = true;
};

/*
    Returns specified property's value.

    Arguments
        modelProperty [string]
            property name

    Returns
        value
*/
APIModel.prototype.getModelProperty = function (modelProperty) {
  return this._getObjectProperty(this, modelProperty);
};

/*
    Returns the uri associated with an action.

    Arguments
        action [string]
            action name

    Returns
        uri string if it exists; null otherwise
*/
APIModel.prototype.getActionUri = function (action) {
  var index = action.lastIndexOf('.');
  if (index === -1) {
    if (typeof this._links[action] !== 'undefined') {
      var link = this._links[action];
      return link.uri;
    }
  } else {
    var actionPath = action.substring(0, index);
    action = action.substring(index + 1);
    var model = this._getObjectProperty(this, actionPath);
    if (model instanceof APIModel) {
      if (typeof model._links[action] !== 'undefined') {
        var link = model._links[action];
        return link.uri;
      }
    }
  }
  return null;
};

APIModel.prototype._loadSchema = function (action, callbackOrPromise, localStoreBool) {
  // Using API endpoint
  var link = '';
  if (this._links[action] != null) {
    link = '/schemas?filter=' + action;
    var schemaReq = new APIRequest(
      link,
      'GET',
      null,
      this._onLoadSchema.bind(this, action, callbackOrPromise),
      null,
      localStoreBool
    );
    schemaReq.send();
  } else {
    this._doMethodCompletion(false, callbackOrPromise, null);
  }
};

APIModel.prototype._onLoadSchema = function (action, callbackOrPromise, response, status) {
  if (status == 200 && response.length > 0) {
    var schema = JSON.parse(response[0].schema);
    this._schemas[action] = schema;
    this._doMethodCompletion(true, callbackOrPromise, schema);
  } else {
    this._doMethodCompletion(false, callbackOrPromise, null);
  }
};

APIModel.prototype._onAction = function (callbackOrPromise, data, response, request) {
  this._initialized = true;
  this._doMethodCompletion(true, callbackOrPromise, data, response, request);
  this._initializedPromise.resolve(data, response, request);
};

APIModel.prototype._getModelWithURI = function (callbackOrPromise) {
  try {
    this._obtainLock();
  } catch (e) {
    this._addCallbackToPending(callbackOrPromise);
    throw e;
  }

  var request = new APIRequest(
    this._uri,
    'get',
    null,
    this._onGetModel.bind(this, callbackOrPromise)
  );
  request.send();
};

APIModel.prototype._getModel = function (callbackOrPromise) {
  this.performAction('self', null, this._onGetModel.bind(this, callbackOrPromise));
};

APIModel.prototype._onGetModel = function (callbackOrPromise, data, response, request) {
  this._releaseLock();
  this._callPendingCallbacks();
  if (response === 200) {
    this._memory = $.extend({}, data);
    this.updateModel(data);
    this._persistent = true;
  }
  this._initialized = true;
  this._doMethodCompletion(true, callbackOrPromise, data, response, request);
  this._initializedPromise.resolve(data, response, request);
};

APIModel.prototype._addCallbackToPending = function (callbackOrPromise) {
  this._pendingCallbacks.push(callbackOrPromise);
};

APIModel.prototype._callPendingCallbacks = function () {
  while (this._pendingCallbacks.length) {
    var callbackOrPromise = this._pendingCallbacks.pop();
    if (typeof callbackOrPromise === 'function') {
      callbackOrPromise(callbackArguments);
    } else if (actionResolved && typeof callbackOrPromise.resolve === 'function') {
      callbackOrPromise.resolve(callbackArguments);
    }
  }
};

APIModel.prototype._obtainLock = function () {
  if (!this._lock) {
    this._lock = true;
  } else {
    throw new APIModelException(
      'APIModelConcurrencyException',
      'model is currently locked by another operation'
    );
  }
};

APIModel.prototype._releaseLock = function () {
  this._lock = false;
};

/*
    Sets nested object property, when property is expressed as a string
        * @param object: Object with the property needed to be set
        * @param propertyPath: Path to the object property expressed as a string
        * @oaram value: New value for object property
        Example Call: this._setObjectProperty(myObj,"path.to.nested[0].property",value)
        This will set myObj.path.to.nested[0].property = value
 */
APIModel.prototype._setObjectProperty = function (obj, path, value) {
  if (typeof path === 'string') {
    path = path.replace(/\[/g, '.');
    path = path.replace(/\]/g, '');
    path = path.split('.');
  }
  if (path.length > 1) {
    var attr = path.shift();
    if (obj[attr] == null || typeof obj[attr] !== 'object') {
      if (!isNaN(parseInt(attr))) {
        obj[parseInt(attr)] = {};
      } else {
        obj[attr] = {};
      }
    }
    if (obj[attr] instanceof APIModel) {
      // Next property is model, delegate to model
      obj[attr].setModelProperty(path.join('.'), value);
    } else {
      this._setObjectProperty(obj[attr], path, value);
    }
  } else {
    obj[path[0]] = value;
    this._persistent = false;
  }
};

APIModel.prototype._removeObjectProperty = function (obj, path) {
  if (typeof path === 'string') {
    path = path.replace(/\[/g, '.');
    path = path.replace(/\]/g, '');
    path = path.split('.');
  }
  if (path.length > 1) {
    var attr = path.shift();
    if (obj[attr] == null || typeof obj[attr] !== 'object') {
      if (!isNaN(parseInt(attr))) {
        obj[parseInt(attr)] = {};
      } else {
        obj[attr] = {};
      }
    }
    if (obj[attr] instanceof APIModel) {
      // Next property is model, delegate to model
      obj[attr].removeModelProperty(path.join('.'));
    } else {
      this._removeObjectProperty(obj[attr], path);
    }
  } else {
    delete obj[path[0]];
  }
};

/*
    Returns nested object property, when property is expressed as a string
        * @param object: Object with the property needed
        * @param propertyPath: path to the object property expressed as a string
        Example Call: this._getObjectProperty(myObj,"path.to.nested[0].property")
        This will return myObj.path.to.nested[0].property
 */
APIModel.prototype._getObjectProperty = function (object, propertyPath) {
  if (typeof object !== 'object') {
    return undefined;
  }
  var propertyPathArr = propertyPath.split('.');
  for (var i = 0; i < propertyPathArr.length; i++) {
    var arrayCheck = propertyPathArr[i].match(/\[\d+\]/g);
    if (arrayCheck && arrayCheck.length > 0) {
      var array = propertyPathArr[i].replace(/\[\d+\]/g, '');
      array = object[array];
      object = this._getArrayProperty(array, propertyPathArr[i].match(/\[\d+\]/g).join(''));
    } else {
      if (!object || typeof object[propertyPathArr[i]] === 'undefined') return undefined;
      object = object[propertyPathArr[i]];
    }
    // Next property is model, delegate to model
    var nextProp = propertyPathArr.slice(i + 1);
    if (object instanceof APIModel && nextProp.length > 0) {
      return object.getModelProperty(propertyPathArr.slice(i + 1).join('.'));
    }
  }
  return object;
};

/*
    Returns nested array property, when property is expressed as a string
        * @param array: Array with the property needed
        * @param propertyPath: path to the array property expressed as a string
        Example Call: this._getArrayProperty(myArray,"[0][0][1]")
        This will return myArray[0][0][1];
 */
APIModel.prototype._getArrayProperty = function (array, propertyPath) {
  if (Object.prototype.toString.call(array) != '[object Array]') {
    return undefined;
  }
  var expectedArrayLength = propertyPath.length;
  propertyPath = propertyPath.replace(/\[/g, '');
  expectedArrayLength = expectedArrayLength - propertyPath.length;
  propertyPath = propertyPath.slice(0, -1);
  var propertyPathArr = propertyPath.split(']');
  if (propertyPathArr.length != expectedArrayLength) return undefined;
  for (var i = 0; i < propertyPathArr.length; i++) {
    array = array[propertyPathArr[i]];
  }
  return array;
};

APIModel.prototype._doMethodCompletion = function (isSuccess, callbackOrPromise) {
  if (callbackOrPromise) {
    var args = Array.prototype.slice.call(arguments, 2);
    if (callbackOrPromise) {
      if (typeof callbackOrPromise === 'function') {
        callbackOrPromise.apply(null, args);
      } else if (isSuccess && typeof callbackOrPromise.resolve === 'function') {
        callbackOrPromise.resolve.apply(null, args);
      } else if (!isSuccess && typeof callbackOrPromise.reject === 'function') {
        callbackOrPromise.reject.apply(null, args);
      }
    }
  }
};

/*
    Processes passed in data by recursively parsing properties of objects and
    nested objects. As part of processing the data, rel links are processed
    and nested APIModel objects are created when detected. Creates a copy of
    data (deep copy) to a maximum depth as defined by this._MAX_DEPTH. Processing
    is halted once maximum depth has been reached, and the rest of the object is
    included only as an object reference. Additional rel links or APIModel objects
    are not created in the rest of the nested object.

    Arguments:
        obj [object] (required):
            The object to process.

        _depth [Integer]:
            Should not be used. Used to internally track the depth of recursion.

    Returns:
        [object]
            The processed data.
*/
APIModel.prototype._processData = function(data, _depth) {
  if (_depth == null) {
    this._maxDepthError = false;
    _depth = -1;
  }
  _depth++;

  if (typeof data !== 'undefined') {
    if (data instanceof Object) {
      var newObj = {};
      if (data instanceof Array) {
        newObj = [];
      }
      for (var key in data) {
        if (key.indexOf('_') !== 0 && typeof data[key] !== 'function') {
          if (data[key] && data[key].links) {
            var newModel = new APIModel(this._name + '_' + key);
            newModel.updateModel(data[key]);
            newObj[key] = newModel;
          } else {
            if (_depth <= this._MAX_DEPTH) {
              newObj[key] = this._processData(data[key], _depth);
            } else {
              newObj[key] = data[key];
            }
          }
        }
      }

      if (_depth > this._MAX_DEPTH && !this._maxDepthError) {
        this._maxDepthError = true;
        // See documentation for this method for details.
        console.warn(
            'APIModel: Maximum depth exceeded for ' +
            this._name +
            ' data; fallback to object reference. See documentation for details.');
      }

      return newObj;
    } else {
      return data;
    }
  }
};

/*
    Processes object and returns a links object to be appended to the object.

    Arguments:
        data [object]:
            The data object to process.

    Returns:
        [object]
            Returns processed link object. If no links object can be found, returns null.
*/
APIModel.prototype._processLinks = function(data) {
  if (data.links) {
    var actions = {};
    for (var link = 0; link < data.links.length; link++) {
      var action = data.links[link];
      actions[action.rel] = {};
      actions[action.rel].uri = action.uri;
      actions[action.rel].method = action.method;
      actions[action.rel].options = action.options;
    }
    return actions;
  }
  return null;
};